// Property slice - matching admin-web structure
import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { setUser, resetAuth } from '../authSlice';
import { PURGE } from 'redux-persist';
import { IProperty } from '@/types/admin/navigation';

const initialState: IProperty = {
  id: 0,
  marketingName: '',
  organizationId: 0,
};

const propertySlice = createSlice({
  name: 'property',
  initialState,
  reducers: {
    reset: () => initialState,
    setProperty: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(PURGE, () => {
        return initialState;
      })
      .addCase(setUser, (state, { payload }) => {
        const user: any = payload;
        
        if (!user || !user.roles || user.roles.length === 0) {
          return initialState;
        }

        // Get property from first role (matching admin-web logic)
        const firstRole = user.roles[0];
        const property = firstRole.property;

        if (!property) {
          return initialState;
        }

        return {
          ...state,
          id: property.id,
          marketingName: property.marketingName,
          organizationId: property.organizationId,
          externalId: property.externalId,
          propertyCashAccountId: property.propertyCashAccountId,
          accountsPayableAccountId: property.accountsPayableAccountId,
          convenienceFeeAccountId: property.convenienceFeeAccountId,
          email: property.email,
          phone: property.phone,
          websites: property.websites,
          faqUrl: property.faqUrl,
          cbxWifiInformationFilePath: property.cbxWifiInformationFilePath,
          address: property.address,
          photoUrl: property.photoUrl,
          photos: property.photos,
          logoUrl: property.logoUrl,
          accountingPeriodEndDate: property.accountingPeriodEndDate,
          featureFlags: property.featureFlags,
        };
      })
      .addCase(resetAuth, () => {
        return initialState;
      });
  },
});

export const { reset, setProperty } = propertySlice.actions;

export default propertySlice.reducer;

